import React from "react";
import { motion } from "framer-motion";
import {
  FaBookOpen,
  FaUniversity,
  FaBrain,
  FaUsers,
  FaGraduationCap,
  FaGlobe,
} from "react-icons/fa";

import secondaryImg from "../assets/senior1.jpeg";


const highlights = [

  {
    title: "Academic Excellence",
    icon: <FaBookOpen />,
  },

  {
    title: "Career Guidance",
    icon: <FaUniversity />,
  },

  {
    title: "Research & Innovation",
    icon: <FaBrain />,
  },

  {
    title: "Leadership Opportunities",
    icon: <FaUsers />,
  },

  {
    title: "Competitive Exam Preparation",
    icon: <FaGraduationCap />,
  },

  {
    title: "Global Citizenship",
    icon: <FaGlobe />,
  },

];



const Secondary = () => {


return (

<section className="
relative
w-full
py-32
overflow-hidden
bg-gradient-to-br
from-[#f8fbff]
via-[#f5f7fc]
to-[#eef4ff]
">


{/* BACKGROUND */}

<div className="
absolute
top-[-150px]
left-[-150px]
w-[500px]
h-[500px]
bg-blue-200/20
blur-3xl
rounded-full
">
</div>


<div className="
absolute
bottom-[-150px]
right-[-150px]
w-[500px]
h-[500px]
bg-yellow-200/20
blur-3xl
rounded-full
">
</div>



<div className="
max-w-[1600px]
mx-auto
px-6
relative
z-10
">



{/* ================= HERO ================= */}



<motion.div

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

className="
text-center
mb-32
"

>



<div className="
inline-flex
items-center
gap-3
px-8
py-4
rounded-full
bg-white
border
border-blue-100
shadow-lg
mb-10
">


<span className="
text-blue-600
text-xl
">

🎓

</span>



<p className="
uppercase
tracking-[6px]
text-blue-600
text-sm
font-black
">

Grades IX to XII

</p>


</div>






<h1 className="
text-5xl
md:text-7xl
xl:text-8xl
font-black
text-[#07294d]
leading-[1.05]
">


<span className="
relative
inline-block
pb-8
">


Secondary

<br/>

Stage




<span className="
absolute
left-1/2
-translate-x-1/2
bottom-1
w-[110%]
h-6
bg-gradient-to-r
from-blue-100
via-blue-200
to-blue-100
rounded-full
">

</span>


</span>


</h1>






<p className="
text-3xl
md:text-5xl
font-black
text-[#07294d]
mt-12
">

Preparing Future-Ready Leaders

</p>




<p className="
max-w-[1200px]
mx-auto
text-gray-600
text-xl
leading-10
mt-10
">


The Secondary Stage equips students with academic excellence,
multidisciplinary learning, career readiness, leadership,
and the confidence to excel in higher education and beyond.


</p>



</motion.div>







{/* ================= IMAGE SECTION ================= */}



<div className="
grid
lg:grid-cols-2
gap-16
items-center
mb-32
">



{/* IMAGE */}


<motion.div

initial={{
opacity:0,
x:-50
}}

whileInView={{
opacity:1,
x:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

className="
relative
"

>


<div className="
relative
overflow-hidden
rounded-[55px]
shadow-[0_35px_120px_rgba(0,0,0,0.15)]
group
">


<img

src={secondaryImg}

alt="Secondary Stage"

className="
w-full
h-[760px]
object-cover
group-hover:scale-105
transition
duration-700
"

/>



<div className="
absolute
inset-0
bg-gradient-to-t
from-[#021427]/90
via-transparent
to-transparent
">
</div>





<motion.div

animate={{
y:[0,-12,0]
}}

transition={{
duration:4,
repeat:Infinity
}}

className="
absolute
bottom-8
left-8
right-8
bg-white/90
backdrop-blur-xl
rounded-[35px]
p-8
shadow-xl
"

>


<h3 className="
text-3xl
font-black
text-[#07294d]
mb-4
">

Preparing Future-Ready Leaders

</h3>



<p className="
text-gray-600
leading-8
">

The Secondary Stage equips students with academic excellence,
multidisciplinary learning, career readiness, leadership,
and confidence.

</p>


</motion.div>


</div>


</motion.div>
{/* ================= RIGHT CONTENT ================= */}


<motion.div

initial={{
opacity:0,
x:50
}}

whileInView={{
opacity:1,
x:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

>


<div className="
bg-white
rounded-[55px]
shadow-[0_35px_120px_rgba(0,0,0,0.08)]
p-10
md:p-16
relative
overflow-hidden
">


{/* TOP LINE */}

<div className="
absolute
top-0
left-0
w-full
h-[8px]
bg-gradient-to-r
from-blue-600
via-cyan-400
to-blue-600
">
</div>





{/* DECORATION */}

<div className="
absolute
top-[-80px]
right-[-80px]
w-[240px]
h-[240px]
border-[25px]
border-blue-100
rounded-full
">
</div>






{/* ICON */}


<div className="
w-24
h-24
rounded-[32px]
bg-blue-600
text-white
flex
items-center
justify-center
text-5xl
shadow-xl
mb-10
relative
z-10
">


🎓


</div>







<h2 className="
text-5xl
font-black
text-[#07294d]
leading-tight
mb-8
relative
z-10
">


Preparing

<br/>

Future-Ready

<br/>

Leaders


</h2>






<div className="
w-28
h-[6px]
bg-blue-200
rounded-full
mb-10
">
</div>







<p className="
text-gray-600
text-xl
leading-10
relative
z-10
">


The Secondary Stage equips students with academic excellence,
multidisciplinary learning, career readiness, leadership,
and the confidence to excel in higher education and beyond.


</p>




</div>


</motion.div>



</div>









{/* ================= HIGHLIGHTS TITLE ================= */}



<motion.div

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.7
}}

viewport={{
once:true
}}

className="
text-center
mb-20
"

>



<h2 className="
text-5xl
md:text-6xl
font-black
text-[#07294d]
">


Highlights


</h2>



<div className="
w-28
h-[6px]
bg-blue-500
rounded-full
mx-auto
mt-8
">
</div>



</motion.div>







{/* ================= CARDS ================= */}



<div className="
grid
md:grid-cols-2
xl:grid-cols-3
gap-10
">


{
highlights.map((item,index)=>(


<motion.div

key={index}

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

transition={{
duration:.5,
delay:index*.08
}}

viewport={{
once:true
}}

whileHover={{
y:-12
}}

className="
group
relative
overflow-hidden
bg-white
rounded-[45px]
p-10
shadow-[0_25px_90px_rgba(0,0,0,0.08)]
border
border-blue-100
"

>


{/* TOP BAR */}

<div className="
absolute
top-0
left-0
w-full
h-[7px]
bg-gradient-to-r
from-blue-600
via-cyan-400
to-blue-600
">
</div>






{/* NUMBER */}

<div className="
absolute
top-3
right-5
text-[90px]
font-black
text-blue-50
">

0{index+1}

</div>







{/* ICON */}

<div className="
relative
z-10
w-20
h-20
rounded-[28px]
bg-blue-600
text-white
flex
items-center
justify-center
text-4xl
shadow-xl
mb-8
group-hover:scale-110
transition
duration-300
">


{item.icon}


</div>






<h3 className="
relative
z-10
text-2xl
md:text-3xl
font-black
text-[#07294d]
leading-tight
">


{item.title}


</h3>






<div className="
w-20
h-[5px]
bg-blue-200
rounded-full
mt-6
">

</div>




</motion.div>


))

}



</div>



</div>


</section>


);

};


export default Secondary;